import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  AccessTime as DetentionIcon,
  LocalGroceryStore as LumperIcon,
} from "@mui/icons-material";
import PageLayout from "../../components/layout/PageLayout";
import PageTitle from "../../components/common/PageTitle";
import TabbedPageCard from "../../components/common/TabbedPageCard";
import DetentionsTab from "./components/DetentionsTab";
import LumpersTab from "./components/LumpersTab";

const DETENTION_TAB_INDEX: Record<string, number> = {
  detentions: 0,
  lumpers: 1,
};

const DetentionLumpersPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get("tab");
    return tab && tab in DETENTION_TAB_INDEX ? DETENTION_TAB_INDEX[tab] : 0;
  });

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    if (index === 1) {
      setSearchParams({ tab: "lumpers" }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  };

  return (
    <PageLayout variant="fullHeight">
      <PageTitle title="Detention / Lumper" icon={<DetentionIcon />} />

      <TabbedPageCard
        variant="flat"
        fullHeight
        idPrefix="detention-lumper"
        ariaLabel="Detention and Lumper tabs"
        selectedTab={activeTab}
        onTabChange={handleTabChange}
        tabs={[
          {
            id: "detentions",
            label: "Detention",
            icon: <DetentionIcon />,
            iconPosition: "start",
            content: <DetentionsTab />,
          },
          {
            id: "lumpers",
            label: "Lumper",
            icon: <LumperIcon />,
            iconPosition: "start",
            content: <LumpersTab />,
          },
        ]}
      />
    </PageLayout>
  );
};

export default DetentionLumpersPage;
